var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.831,17.057c0,-0 3.979,-3.335 6.296,-5.277c0.294,-0.247 0.705,-0.3 1.053,-0.138c0.348,0.162 0.57,0.512 0.57,0.896c0,4.577 0,15.347 0,19.924c0,0.384 -0.222,0.734 -0.57,0.896c-0.348,0.162 -0.759,0.109 -1.053,-0.138c-2.317,-1.942 -6.296,-5.277 -6.296,-5.277l-2.76,0c-3.005,0 -5.441,-2.436 -5.441,-5.441l-0,-0.004c-0,-3.005 2.436,-5.441 5.441,-5.441l2.76,-0Zm12.486,-0.529c0,0 2.053,2.169 2.053,5.972c0,3.803 -2.053,5.972 -2.053,5.972c-0.579,0.591 -0.568,1.542 0.023,2.121c0.592,0.579 1.543,0.568 2.122,-0.023c-0,-0 2.908,-2.904 2.908,-8.07c0,-5.166 -2.908,-8.07 -2.908,-8.07c-0.579,-0.591 -1.53,-0.602 -2.122,-0.023c-0.591,0.579 -0.602,1.53 -0.023,2.121Z",
    fill: props.fill
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/icon_sound.f48226009e0c2d6a1ead1d69637cb886.svg";
export { ForwardRef as ReactComponent };